const config = {
  apiGateway: {
    REGION: 'ap-southeast-1',
    PHY_LOCATION_APIGATEWAY_URL: 'https://lsb09463xd.execute-api.ap-southeast-1.amazonaws.com/prod',
    INTERNAL_PHY_LOCATION_APIGATEWAY_URL: 'https://o7bkjspdc6.execute-api.ap-southeast-1.amazonaws.com/prod',
    COMPANY_APIGATEWAY_URL: 'https://v8gvy8zyd6.execute-api.ap-southeast-1.amazonaws.com/prod',
  },
  reactApp: {
    VERSION: 'taxonomy-physical-location-1.16.5',
    HOSTNAME: 'https://locations.staging.oceanagold.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.staging.oceanagold.forwoodsafety.com',
    WEBSOCKET: 'wss://auduqo2dzb.execute-api.ap-southeast-1.amazonaws.com/staging'
  },
};

export default config;